import { h } from '@atomify/jsx';
import { Col } from '@atoms/col/col';
import { Container } from '@atoms/container/container';
import { Row } from '@atoms/row/row';

export interface CalloutProps {
    title: string | Text;
    titleElement?: string;
    subtitle: string | Text;
    classes?: string;
    children?: Element[];
}

export const Callout = ({ title, titleElement, subtitle, classes, children }: CalloutProps) => {
    const Title = titleElement || 'h2';

    return (
        <Container extraClass={classes}>
            <Row>
                <Col cols={[12, , 10, 8]} pre={[, , 1, 2]}>
                    <div class="c-callout">
                        <div class="callout__content">
                            <Title
                                class="u-body-large-bold u-margin-bottom-1"
                                js-hook-callout-title>
                                {title}
                            </Title>
                            <p class="u-body-normal" js-hook-callout-subtitle>
                                {subtitle}
                            </p>
                        </div>
                        <div class="callout__cta">{children}</div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
